<template>
    <b-col md="2" class="bd-light sidebar d-none d-sm-none d-md-block">
        <div class="sidebar-inner">
            <ul class="nav flex-column">
                <li class="nav-item" v-if="1===2">
                    <b-nav-item to="/">
                        <icon icon="home" class="fa-fw"/>
                        Inicio
                    </b-nav-item>
                </li>
                <li class="nav-item">
                    <b-nav-item to="/casas">
                        <icon icon="building" class="fa-fw"/>
                        Casas
                    </b-nav-item>
                </li>
                <li class="nav-item">
                    <b-nav-item to="/lotes">
                        <icon icon="tags" class="fa-fw"/>
                        Lotes
                    </b-nav-item>
                </li>
                <li class="nav-item">
                    <b-nav-item to="/etapas">
                        <icon icon="map-signs" class="fa-fw"/>
                        Etapas
                    </b-nav-item>
                </li>
                <li class="nav-item">
                    <b-nav-item to="/tareas">
                        <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="tasks-light" fill="#000000" fill-rule="nonzero">
                                    <path d="M4.57706152,5.71247902 C4.53013175,5.66524672 4.46629947,5.6386863 4.39971649,5.6386863 C4.3331335,5.6386863 4.26930122,5.66524672 4.22237145,5.71247902 L2.00360539,7.93124509 L0.784846568,6.71248626 C0.687228059,6.61493172 0.529025018,6.61493172 0.431406509,6.71248626 L0.0770289436,7.06686383 C0.030084343,7.11375623 0.00370674867,7.17738732 0.00370674867,7.24374011 C0.00370674867,7.3100929 0.030084343,7.37372398 0.0770289436,7.42061639 L1.82704161,9.17062906 C1.92466012,9.2681836 2.08286316,9.2681836 2.18048167,9.17062906 L4.93050158,6.42060915 C4.97744618,6.37371674 5.00382378,6.31008566 5.00382378,6.24373287 C5.00382378,6.17738008 4.97744618,6.11374899 4.93050158,6.06685659 L4.57706152,5.71247902 Z M2.00141788,11.2437691 C1.44922638,11.2437691 0.988910545,11.6915848 0.988910545,12.2437691 C0.988910545,12.7959678 1.44922638,13.2437835 2.00141788,13.2437835 C2.55370662,13.2437835 3.00142512,12.7960651 3.00142512,12.2437691 C3.00142512,11.6914876 2.55370662,11.2437691 2.00141788,11.2437691 Z M4.57706152,0.712442823 C4.53013175,0.665210518 4.46629947,0.638650104 4.39971649,0.638650104 C4.3331335,0.638650104 4.26930122,0.665210518 4.22237145,0.712442823 L2.00360539,2.93120889 L0.784846568,1.71245006 C0.687228059,1.61489552 0.529025018,1.61489552 0.431406509,1.71245006 L0.0770289436,2.06682763 C0.030084343,2.11372003 0.00370674867,2.17735112 0.00370674867,2.24370391 C0.00370674867,2.3100567 0.030084343,2.37368779 0.0770289436,2.42058019 L1.82704161,4.17059286 C1.92466012,4.2681474 2.08286316,4.2681474 2.18048167,4.17059286 L4.93050158,1.42057295 C4.97744618,1.37368055 5.00382378,1.31004946 5.00382378,1.24369667 C5.00382378,1.17734388 4.97744618,1.11371279 4.93050158,1.06682039 L4.57706152,0.712442823 Z M15.7537049,11.7437727 L6.25363616,11.7437727 C6.11556397,11.7437727 6.00363435,11.8557023 6.00363435,11.9937745 L6.00363435,12.4937781 C6.00363435,12.6318503 6.11556397,12.7437727 6.25363616,12.7437727 L15.7537049,12.7437727 C15.8917771,12.7437727 16.0037067,12.6318503 16.0037067,12.4937781 L16.0037067,11.9937745 C16.0037067,11.8557023 15.8917771,11.7437727 15.7537049,11.7437727 Z M15.7537049,1.74370029 L6.25363616,1.74370029 C6.11556397,1.74370029 6.00363435,1.85562991 6.00363435,1.9937021 L6.00363435,2.49370572 C6.00363435,2.63177791 6.11556397,2.74370029 6.25363616,2.74370029 L15.7537049,2.74370029 C15.8917771,2.74370029 16.0037067,2.63177791 16.0037067,2.49370572 L16.0037067,1.9937021 C16.0037067,1.85562991 15.8917771,1.74370029 15.7537049,1.74370029 Z M15.7537049,6.74373649 L6.25363616,6.74373649 C6.11556397,6.74373649 6.00363435,6.85566611 6.00363435,6.9937383 L6.00363435,7.49374192 C6.00363435,7.6318141 6.11556397,7.74373649 6.25363616,7.74373649 L15.7537049,7.74373649 C15.8917771,7.74373649 16.0037067,7.6318141 16.0037067,7.49374192 L16.0037067,6.9937383 C16.0037067,6.85566611 15.8917771,6.74373649 15.7537049,6.74373649 Z"></path>
                                </g>
                            </g>
                        </svg>
                        Tareas
                    </b-nav-item>
                </li>
                <li class="nav-item">
                    <b-nav-item to="/usuarios">
                        <icon icon="users" class="fa-fw"/>
                        Clientes
                    </b-nav-item>
                </li>
            </ul>
        </div>
    </b-col>
</template>

<script>
    export default {
        name: "Sidebar",
    }
</script>

<style scoped>
    .sidebar {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
        padding: 56px 0 0;
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
    }

    .sidebar-inner {
        padding-top: 10px;
    }

    .sidebar .nav-link {
        opacity: 0.65;
        color: #1f1f1f
    }

    .sidebar .nav-link:hover,
    .sidebar .nav-link.active {
        opacity: 1;
    }

    .bd-light {
        background: #f8f9fa;
    }
</style>